export const worksList = [
  {
    id: 1,
    title: "春日信笺",
    type: "电视剧",
    year: 2026,
    status: "未上映",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20portrait%20style%20poster%20with%20soft%20spring%20light%20and%20delicate%20blossom%20branches%2C%20warm%20cream%20and%20coral%20tones%2C%20minimal%20editorial%20drama%20key%20visual%2C%20refined%20and%20airy%20atmosphere&width=600&height=800&seq=yn-work-01&orientation=portrait",
    director: "田川诚",
    cast: "大岛优香 / 前田悠斗 / 佐藤铃",
    genre: "都市 / 情感",
    duration: "45 分钟 × 12 集",
    rating: 8.6,
    synopsis:
      "快节奏的城市里，一位坚持手写信件的图书编辑，在一沓旧信中发现了一段被时光掩埋的心事，也重新审视了自己的生活与选择。",
    role: "饰 林知夏（图书编辑）",
    roleIntro:
      "林知夏是位外冷内热的图书编辑，习惯用文字记录情绪，却在现实生活中小心翼翼。大岛优香以细腻克制的表演，呈现了人物从封闭到坦然的心路历程，多场无声戏份被观众称为「教科书级别的情绪表达」。",
    stills: [
      "https://readdy.ai/api/search-image?query=soft%20spring%20interior%20with%20sunlight%20through%20window%20and%20stack%20of%20old%20letters%2C%20warm%20cream%20tones%2C%20minimal%20editorial%20drama%20still%2C%20gentle%20atmosphere&width=800&height=600&seq=yn-work-01-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=quiet%20bookstore%20corner%20with%20wooden%20shelves%20and%20warm%20lamp%20light%2C%20soft%20coral%20accents%2C%20cinematic%20editorial%20drama%20still%2C%20calm%20and%20refined&width=800&height=600&seq=yn-work-01-b&orientation=landscape",
    ],
  },
  {
    id: 2,
    title: "逆光而行",
    type: "电影",
    year: 2025,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=dramatic%20backlit%20portrait%20style%20movie%20poster%20with%20deep%20amber%20and%20charcoal%20tones%2C%20haze%20and%20light%20rays%2C%20cinematic%20suspense%20key%20visual%2C%20minimal%20and%20tense%20atmosphere&width=600&height=800&seq=yn-work-02&orientation=portrait",
    director: "黑木隆一",
    cast: "大岛优香 / 高桥凉介 / 石田未来",
    genre: "悬疑 / 剧情",
    duration: "128 分钟",
    rating: 8.9,
    synopsis:
      "一位调查者在追查真相的过程中，逐渐发现自己所依赖的记忆并不完整。真相与谎言交错，她必须在逆光中重新辨认前行的方向。",
    role: "饰 宫野灯里（调查者）",
    roleIntro:
      "宫野灯里是全片情绪最复杂的角色，冷静的外表下藏着巨大的不安与执念。大岛优香为此进行了大量体能与心理训练，呈现出一个在崩溃边缘仍保持克制的女性形象。",
    stills: [
      "https://readdy.ai/api/search-image?query=moody%20corridor%20with%20single%20light%20source%20and%20long%20shadows%2C%20deep%20amber%20and%20charcoal%20tones%2C%20cinematic%20suspense%20film%20still%2C%20tense%20minimal%20atmosphere&width=800&height=600&seq=yn-work-02-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=rainy%20city%20street%20at%20night%20with%20reflections%20and%20warm%20window%20lights%2C%20slate%20and%20amber%20tones%2C%20cinematic%20suspense%20film%20still%2C%20quiet%20tension&width=800&height=600&seq=yn-work-02-b&orientation=landscape",
    ],
  },
  {
    id: 3,
    title: "雾中灯塔",
    type: "电影",
    year: 2025,
    status: "未上映",
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20lighthouse%20movie%20poster%20with%20pale%20mist%20and%20muted%20slate%20tones%2C%20mysterious%20cinematic%20key%20visual%2C%20minimal%20abstract%20seascape%2C%20editorial%20and%20quiet&width=600&height=800&seq=yn-work-03&orientation=portrait",
    director: "黑木隆一",
    cast: "大岛优香 / 佐伯辽 / 森川千鹤",
    genre: "悬疑 / 剧情",
    duration: "112 分钟",
    rating: 8.4,
    synopsis:
      "一座海边小镇的旧案被重新翻开，灯塔在浓雾中忽明忽暗，所有线索都指向那个沉默寡言却始终在场的女人。",
    role: "饰 户田沙耶（灯塔守望者之女）",
    roleIntro:
      "户田沙耶是解开整个谜团的关键人物，台词不多，却需要大量的眼神与肢体表达。大岛优香以极具留白的表演方式，让这个角色成为全片最令人回味的存在。",
    stills: [
      "https://readdy.ai/api/search-image?query=coastal%20cliff%20in%20heavy%20fog%20with%20distant%20lighthouse%20beam%2C%20muted%20slate%20and%20pale%20blue%20tones%2C%20cinematic%20mystery%20film%20still%2C%20quiet%20and%20vast&width=800&height=600&seq=yn-work-03-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=old%20stone%20lighthouse%20interior%20with%20spiral%20stairs%20and%20soft%20misty%20light%2C%20muted%20cool%20tones%2C%20cinematic%20mystery%20film%20still%2C%20lonely%20atmosphere&width=800&height=600&seq=yn-work-03-b&orientation=landscape",
    ],
  },
  {
    id: 4,
    title: "慢生活手记",
    type: "综艺",
    year: 2026,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20countryside%20variety%20show%20poster%20with%20soft%20green%20hills%20and%20warm%20wooden%20details%2C%20cream%20and%20sage%20tones%2C%20minimal%20lifestyle%20key%20visual%2C%20calm%20and%20gentle&width=600&height=800&seq=yn-work-04&orientation=portrait",
    director: "藤井淳",
    cast: "大岛优香 / 嘉宾群像",
    genre: "生活 / 观察",
    duration: "每期 60 分钟",
    rating: 8.2,
    synopsis:
      "放下忙碌，重新生活。嘉宾在小镇中经营一间小院、料理三餐，用镜头记录最本真的日常与慢下来的时光。",
    role: "固定嘉宾",
    roleIntro:
      "在节目中，大岛优香展现了与影视角色截然不同的一面：会为一件晾晒好的床单开心，也会认真地跟邻居学做点心。真实松弛的状态让观众直呼「被治愈到了」。",
    stills: [
      "https://readdy.ai/api/search-image?query=sunny%20courtyard%20with%20hanging%20linen%20and%20potted%20plants%2C%20warm%20cream%20and%20sage%20tones%2C%20lifestyle%20variety%20still%2C%20cozy%20and%20bright&width=800&height=600&seq=yn-work-04-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=rustic%20kitchen%20with%20fresh%20ingredients%20and%20ceramic%20plates%2C%20warm%20neutral%20tones%2C%20lifestyle%20variety%20still%2C%20homely%20and%20calm&width=800&height=600&seq=yn-work-04-b&orientation=landscape",
    ],
  },
  {
    id: 5,
    title: "南岸之夏",
    type: "电视剧",
    year: 2024,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=summer%20seaside%20drama%20poster%20with%20soft%20golden%20sunset%20and%20gentle%20waves%2C%20warm%20peach%20and%20blue%20tones%2C%20minimal%20romantic%20key%20visual%2C%20airy%20and%20refined&width=600&height=800&seq=yn-work-05&orientation=portrait",
    director: "田川诚",
    cast: "大岛优香 / 前田悠斗",
    genre: "青春 / 爱情",
    duration: "42 分钟 × 16 集",
    rating: 7.9,
    synopsis:
      "南岸小镇的一个夏天，两个年轻人因一场意外相遇，又在成长的路口各自奔赴。属于青春的遗憾与勇气，都被海风轻轻收下。",
    role: "饰 白石晴海（民宿主理人）",
    roleIntro:
      "白石晴海性格明朗直接，是小镇上的「小太阳」。大岛优香以充满活力的表演塑造了一个有棱有角的女孩形象，也让观众记住了她的笑容。",
    stills: [
      "https://readdy.ai/api/search-image?query=sunset%20over%20calm%20sea%20with%20soft%20golden%20reflection%2C%20warm%20peach%20and%20blue%20tones%2C%20romantic%20drama%20still%2C%20airy%20and%20gentle&width=800&height=600&seq=yn-work-05-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=small%20seaside%20inn%20balcony%20with%20linen%20curtains%20and%20sea%20view%2C%20warm%20cream%20tones%2C%20romantic%20drama%20still%2C%20bright%20and%20calm&width=800&height=600&seq=yn-work-05-b&orientation=landscape",
    ],
  },
  {
    id: 6,
    title: "长夜微光",
    type: "电影",
    year: 2024,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=night%20city%20movie%20poster%20with%20soft%20warm%20window%20lights%20and%20deep%20indigo%20sky%2C%20cinematic%20drama%20key%20visual%2C%20minimal%20and%20emotional%2C%20editorial&width=600&height=800&seq=yn-work-06&orientation=portrait",
    director: "佐佐木香",
    cast: "大岛优香 / 石田未来 / 高桥凉介",
    genre: "剧情 / 家庭",
    duration: "118 分钟",
    rating: 8.7,
    synopsis:
      "一个普通的夜晚，三段彼此交错的人生在城市的不同角落发生。微小的善意像灯火一样传递，最终照亮了所有人的长夜。",
    role: "饰 安藤由纪（夜班护士）",
    roleIntro:
      "安藤由纪是串联起整部影片的温柔线索。大岛优香用内敛而克制的表演，让这个平凡的护士成为观众心中「最想成为的那种人」。",
    stills: [
      "https://readdy.ai/api/search-image?query=hospital%20corridor%20at%20night%20with%20soft%20warm%20lamp%20light%20and%20clean%20lines%2C%20calm%20cool%20and%20warm%20mix%2C%20cinematic%20drama%20still%2C%20quiet%20and%20tender&width=800&height=600&seq=yn-work-06-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=cozy%20city%20apartment%20window%20at%20night%20with%20warm%20lamp%20and%20rain%20outside%2C%20deep%20indigo%20and%20amber%20tones%2C%20cinematic%20drama%20still%2C%20intimate%20and%20gentle&width=800&height=600&seq=yn-work-06-b&orientation=landscape",
    ],
  },
  {
    id: 7,
    title: "纸鸢",
    type: "电影",
    year: 2023,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=paper%20kite%20in%20soft%20blue%20sky%20movie%20poster%2C%20warm%20cream%20and%20sky%20blue%20tones%2C%20minimal%20nostalgic%20key%20visual%2C%20gentle%20and%20airy%2C%20editorial&width=600&height=800&seq=yn-work-07&orientation=portrait",
    director: "佐佐木香",
    cast: "大岛优香 / 森川千鹤",
    genre: "剧情 / 文艺",
    duration: "102 分钟",
    rating: 8.1,
    synopsis:
      "一封寄往故乡的信，让离乡多年的女儿重新回到老屋。风筝还在飞，只是放风筝的人已经换了模样。",
    role: "饰 川上千景（返乡女儿）",
    roleIntro:
      "川上千景带着城市的疲惫回到故乡，与母亲之间有着说不出口的隔阂。大岛优香将这种欲言又止的亲情演绎得格外真实，被誉为其早期代表作之一。",
    stills: [
      "https://readdy.ai/api/search-image?query=open%20field%20with%20paper%20kite%20against%20soft%20blue%20sky%2C%20warm%20cream%20and%20sky%20tones%2C%20nostalgic%20drama%20still%2C%20airy%20and%20free&width=800&height=600&seq=yn-work-07-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=old%20family%20house%20yard%20with%20wooden%20door%20and%20afternoon%20light%2C%20warm%20neutral%20tones%2C%20nostalgic%20drama%20still%2C%20quiet%20and%20warm&width=800&height=600&seq=yn-work-07-b&orientation=landscape",
    ],
  },
  {
    id: 8,
    title: "周末厨房",
    type: "综艺",
    year: 2023,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=cheerful%20cooking%20show%20poster%20with%20fresh%20vegetables%20and%20warm%20kitchen%20light%2C%20orange%20and%20cream%20tones%2C%20minimal%20lifestyle%20key%20visual%2C%20bright%20and%20friendly&width=600&height=800&seq=yn-work-08&orientation=portrait",
    director: "藤井淳",
    cast: "大岛优香 / 嘉宾群像",
    genre: "美食 / 生活",
    duration: "每期 45 分钟",
    rating: 7.6,
    synopsis:
      "每期邀请一位嘉宾走进厨房，用最普通的食材做一顿温暖的饭。做饭的人不同，故事也不同。",
    role: "常驻主持",
    roleIntro:
      "作为常驻主持，大岛优香在节目中展现出难得的生活感，一边熟练地处理食材，一边和嘉宾聊起日常小事，让整个节目温馨又有烟火气。",
    stills: [
      "https://readdy.ai/api/search-image?query=bright%20kitchen%20counter%20with%20fresh%20vegetables%20and%20wooden%20board%2C%20orange%20and%20cream%20tones%2C%20lifestyle%20show%20still%2C%20cheerful%20and%20clean&width=800&height=600&seq=yn-work-08-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=steaming%20homemade%20dish%20on%20table%20with%20warm%20lamp%20light%2C%20warm%20neutral%20tones%2C%20lifestyle%20show%20still%2C%20cozy%20and%20appetizing&width=800&height=600&seq=yn-work-08-b&orientation=landscape",
    ],
  },
  {
    id: 9,
    title: "一封未寄出的信",
    type: "电视剧",
    year: 2022,
    status: "上映",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20envelope%20and%20handwritten%20letter%20drama%20poster%20with%20warm%20sepia%20tones%2C%20minimal%20literary%20key%20visual%2C%20nostalgic%20and%20refined%2C%20editorial&width=600&height=800&seq=yn-work-09&orientation=portrait",
    director: "黑木隆一",
    cast: "大岛优香 / 佐伯辽",
    genre: "年代 / 情感",
    duration: "44 分钟 × 10 集",
    rating: 8.3,
    synopsis:
      "一封始终没能寄出的信，牵起两个人跨越十年的牵挂。有些话说出口太晚，却依然值得被听见。",
    role: "饰 渡边澄（旧书店主）",
    roleIntro:
      "渡边澄守着父亲留下的旧书店，也守着一段未了的心事。大岛优香以沉稳内敛的演绎，让角色的隐忍与深情层层浮现，成为不少观众心中的意难平。",
    stills: [
      "https://readdy.ai/api/search-image?query=old%20bookstore%20with%20stacked%20books%20and%20warm%20afternoon%20light%2C%20sepia%20and%20cream%20tones%2C%20literary%20drama%20still%2C%20nostalgic%20and%20quiet&width=800&height=600&seq=yn-work-09-a&orientation=landscape",
      "https://readdy.ai/api/search-image?query=desk%20with%20fountain%20pen%20and%20unfinished%20letter%20under%20warm%20lamp%2C%20sepia%20tones%2C%20literary%20drama%20still%2C%20intimate%20and%20warm&width=800&height=600&seq=yn-work-09-b&orientation=landscape",
    ],
  },
];